import React from 'react'
import LinkBox from './LinkBox';

export type TelecomLinkBoxRowProps = {};

const TelecomLinkBoxRow: React.FC<TelecomLinkBoxRowProps> = () => {
  return (
    <>
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-center max-w-5xl m-auto pt-20 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/NOM-196-SCFI-2016"} label={"NOM-196-SCFI-2016<br/>(IFT-004-2016)"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/NOM-218-SCFI-2017"} label={"NOM-218-SCFI-2017<br/>(IFT-005-2016)"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/NOM-208-SCFI-2016"} label={"NOM-208-SCFI-2016<br/>(IFT-008-2015)"} />
      </div>
    </div>
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-center max-w-5xl m-auto pt-2 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/NOM-221-SCFI-2017"} label={"NOM-221-SCFI-2017<br/>(IFT-011-2017: Parte 1)"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/NOM-221_2-SCFI-2018"} label={"NOM-221/2-SCFI-2018<br/>(IFT-011-2017: Parte 2)"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/IFT-011-2022"} label={"IFT-011-2022: Parte 3"} />
      </div>
    </div>
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-start max-w-5xl m-auto pt-2 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/IFT-012-2019"} label={"IFT-012-2019"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/IFT-015-2018"} label={"IFT-015-2018"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/IFT-016-2024"} label={"IFT-016-2024"} />
      </div>
    </div>
    
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-start max-w-5xl m-auto pt-2 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"/telecommunications/IFT-017-2023"} label={"IFT-017-2023"} />
      </div>
      <div className="w-full md:w-1/3"></div>
      <div className="w-full md:w-1/3"></div>
    </div>
    </>
  );
}

export default TelecomLinkBoxRow;